import React, { useState, useEffect, useRef } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import HttpService from "../../services/httpService";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    makeStyles,
    Typography,
    useMediaQuery,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Grid,
    FormControl,
    Modal,
    IconButton,
    FormControlLabel,
    Checkbox,
    DialogContentText
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { CSVLink } from "react-csv";
import moment from "moment";
import CloseIcon from "@material-ui/icons/Close";
import { DownloadOutlined } from '@ant-design/icons';
import {
    IoMdArrowDroprightCircle,
    IoMdArrowDropdownCircle,
} from "react-icons/io";
import { Link } from "react-router-dom";
import { ROLENAME } from "../../utils";


const useStyles = makeStyles(() => ({
    paperWrapper: {
        padding: "2rem",
        borderRadius: "10px",
        boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
        backgroundColor: "#fff",
        marginBottom: "1.5rem",
    },
    tableContainer: {
        maxHeight: 688,
        overflow: "auto",
    },
    title: {
        fontWeight: 700,
        color: "#1e293b",
        marginBottom: "16px",
        textAlign: "center",
        fontSize: "20px",
    },
    headerCell: {
        backgroundColor: "#1C375D",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "16px",
        textAlign: "center",
        borderRight: "1px solid rgba(255,255,255,0.2)",
        borderBottom: "1px solid #fff",
        position: "sticky",
        top: 0,
        zIndex: 2,
    },
    topLeftHeader: {
        backgroundColor: "#1C375D",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "16px",
        textAlign: "center",
        padding: "16px",
        borderRight: "1px solid rgba(255,255,255,0.2)",
        borderBottom: "1px solid #fff",
        position: "sticky",
        top: 0,
        left: 0,
        zIndex: 5,
    },
    monthCell: {
        backgroundColor: "#1C375D",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "16px",
        textAlign: "center",
        padding: "16px",
        border: "1px solid #ddd",
        position: "sticky",
        left: 0,
        zIndex: 3,
    },
    bodyCell: {
        textAlign: "center",
        fontSize: "14px",
        padding: "16px",
        border: "1px solid #ddd",
        color: "#263238",
        backgroundColor: "#fff",
    },
    button: {
        fontSize: "12px",
        textTransform: "none",
    },
    modalWrapper: {
        backgroundColor: "white",
        padding: 20,
        margin: "5% auto",
        width: "90%",
        maxHeight: "90vh",
        overflowY: "auto",
        borderRadius: 8,
    },
    modalHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 12,
    },
    closeButton: {
        color: "#000",
        padding: 6,
    },
    csv: {
        display: "flex",
        justifyContent: "flex-end",
        marginBottom: 16,
        gap: 10,
    },
    tableRowEven: {
        backgroundColor: "#f9f9f9",
    },
    tableRowOdd: {
        backgroundColor: "#fff",
    },
    valueCell: {
        fontSize: "14px",
        color: "#263238",
        padding: "10px",
        border: "1px solid #ddd",
        textAlign: "center",
    },
}));

const MonthlyContractFreeze = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const csvButtonRef = useRef();
    const { userDetails } = useSelector((state) => state.user);
    const isMobile = useMediaQuery("(max-width:600px)");
    const [dialogOpen, setDialogOpen] = useState(false);
    const [commonExpCenter, setExpCenter] = useState([]);
    const [commonLocation, setLocation] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState(
        []
    );
    const [storeDateFilter, setStoreDateFilter] = useState({
        startDate: "",
        endDate: "",
    });
    const [data, setData] = useState([]);
    const [clearTriggered, setClearTriggered] = useState(false);
    const [showDetailedModal, setShowDetailedModal] = useState(false);
    const [modelData, setModelData] = useState([]);

    const [remarks, setRemarks] = useState("");
    const [freezeDate, setFreezeDate] = useState("");
    const [showProjects, setShowProjects] = useState(false);
    const [projectList, setProjectList] = useState([]);
    const [selectedProjects, setSelectedProjects] = useState([]);
    const [projectValue, setProjectValue] = useState(0);
    const [bottomsUpData, setBottomsUpData] = useState([]);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [freezeDSODate, setFreezeDSODate] = useState("");
    const [openDSOPopUp, setOpenDSOPopUp] = useState(false);
    const [confirmDSOOpen, setConfirmDSOOpen] = useState(false);
    const [isTransposed, setIsTransposed] = useState(true);
    const [monthlyContractTableCsvData, setMonthlyContractTableCsvData] = useState([]);
    const monthlyContractTableCsvButtonRef = useRef(null);
    const [triggerDownload, setTriggerDownload] = useState(false);

    useEffect(() => {
        if (clearTriggered) {
            bottomsUpDataFunction();
            setClearTriggered(false);
        }
    }, [clearTriggered]);

    useEffect(() => {
        bottomsUpDataFunction();
        expCenters();
        locations();
    }, []);

    const toggleProjectSelection = (index) => {
        setSelectedProjects((prevSelected) => {
            let updated;
            if (prevSelected.includes(index)) {
                updated = prevSelected.filter((i) => i !== index);
            } else {
                updated = [...prevSelected, index];
            }

            const total = updated.reduce(
                (sum, i) => sum + (projectList[i]?.staticSalesWonBudget || 0),
                0
            );
            setProjectValue(total.toFixed(2));
            return updated;
        });
    };

    const toggleSelectAllProjects = () => {
        if (selectedProjects.length === projectList.length) {
            setSelectedProjects([]);
            setProjectValue(0);
        } else {
            const allIndexes = projectList.map((_, idx) => idx);
            const total = projectList.reduce(
                (sum, p) => sum + (p.staticSalesWonBudget || 0),
                0
            );
            setSelectedProjects(allIndexes);
            setProjectValue(total.toFixed(2));
        }
    };

    const expCenters = async () => {
        props.setLoading(true);
        try {
            const res = await HttpService.getExpericenCenters();
            const matched = res.data.filter((e) =>
                userDetails.experienceCenterId.includes(e._id)
            );
            setExpCenter(matched);
        } catch (err) {
            props.setSnackInfo(
                err?.response?.data ?? "Something Went Wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    const locations = async () => {
        props.setLoading(true);
        try {
            const res = await HttpService.getLocation();
            const matched = res.data.filter((e) =>
                userDetails.selectedLocation.includes(e._id)
            );
            setLocation(matched);
        } catch (err) {
            props.setSnackInfo(
                err?.response?.data ?? "Something Went Wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    // this is Bottom Up data API.
    const bottomsUpDataFunction = async () => {
        props.setLoading(true);
        try {
            let userExpeData = userDetails?.experienceCenterId?.map((el) => el);
            let expCenterData = selectedExperienceCenter?.map((el) => el._id);
            let locationData = selectedLocation?.map((el) => el._id);

            const obj = {
                startDate: storeDateFilter.startDate,
                endDate: storeDateFilter.endDate,
                selectedExperienceCenter: expCenterData || [],
                selectedLocation: locationData || [],
                userId: userDetails?._id,
                userExpeCenterId: userExpeData || [],
            };

            props.setSnackInfo("Fetching Data...", "info");

            const response = await HttpService.getBottomsUpData(
                obj
            );
            if (response?.status === 200) {
                const { data } = response;
                if (data) {
                    const filteredData = Object.fromEntries(Object.entries(data).filter(([key]) => key !== "Total"));
                    setBottomsUpData(filteredData);
                    props.setSnackInfo("Data Fetched Successfully", "success");
                } else {
                    setBottomsUpData([]);
                    props.setSnackInfo("No Data Found", "info");
                }
            } else {
                const errMsg =
                    response?.data?.message || "Failed to Fetch Data";
                props.setSnackInfo(errMsg, "error");
            }
        } catch (error) {
            console.error("Error fetching Bottoms Up Data:", error);

            // Extract detailed error message if available
            let message = "Something went wrong!";
            if (error?.response?.data?.message) {
                message = error.response.data.message;
            } else if (error?.message) {
                message = error.message;
            }

            props.setSnackInfo(message, "error");
        } finally {
            props.setLoading(false);
        }
    }

        // Trigger CSV download when data is ready
        useEffect(() => {
            if (triggerDownload && monthlyContractTableCsvData.length > 0) {
                const timer = setTimeout(() => {
                    if (monthlyContractTableCsvButtonRef.current?.link) {
                        try {
                            monthlyContractTableCsvButtonRef.current.link.click();
                        } catch (error) {
                            console.error("Error triggering CSV download:", error);
                            props.setSnackInfo("Error downloading CSV", "error");
                        }
                        setTriggerDownload(false);
                    } else {
                        setTimeout(() => {
                            if (monthlyContractTableCsvButtonRef.current?.link) {
                                monthlyContractTableCsvButtonRef.current.link.click();
                                setTriggerDownload(false);
                            }
                        }, 200);
                    }
                }, 300);
                return () => clearTimeout(timer);
            }
        }, [triggerDownload, monthlyContractTableCsvData]);
    
        // Function to generate CSV data for Bottoms Up table
        const generateMonthlyContractTableCsvData = () => {
            try {
                if (!bottomsUpData || Object.keys(bottomsUpData).length === 0) {
                    return [];
                }
    
                const csvRows = [];
    
                if (isTransposed) {
                    // Transposed view: Experience Centers as rows, Months as columns
                    const { transposedData, months } = getTransposedData();
                    const centers = Object.keys(transposedData);
    
                    // Build header row
                    const headerRow = {
                        "Experience Center": ""
                    };
                    months.forEach((month) => {
                        headerRow[`${month} - Count`] = "";
                        headerRow[`${month} - Value`] = "";
                    });
                    csvRows.push(headerRow);
    
                    // Add data rows for each experience center
                    centers.forEach((center) => {
                        const row = {
                            "Experience Center": center
                        };
                        months.forEach((month) => {
                            const data = transposedData[center];
                            row[`${month} - Count`] = data[`${month}_count`] || 0;
                            row[`${month} - Value`] = data[`${month}_value`] || 0;
                        });
                        csvRows.push(row);
                    });
                } else {
                    // Normal view: Months as rows, Experience Centers as columns
                    // Build header row
                    const headerRow = {
                        "Month": ""
                    };
                    uniqueExperienceCentersBottoms.forEach((center) => {
                        headerRow[`${center} - Count`] = "";
                        headerRow[`${center} - Value`] = "";
                    });
                    csvRows.push(headerRow);
    
                    // Add data rows for each month
                    Object.entries(bottomsUpData).forEach(([monthKey, entries]) => {
                        const row = {
                            "Month": monthKey
                        };
                        uniqueExperienceCentersBottoms.forEach((center) => {
                            const entry = entries.find(
                                (e) => e.experienceCenterName === center
                            );
                            row[`${center} - Count`] = entry?.count > 0 ? entry.count : 0;
                            row[`${center} - Value`] = entry?.value > 0 ? entry.value : 0;
                        });
                        csvRows.push(row);
                    });
                }
    
                return csvRows;
            } catch (error) {
                console.error("Error generating monthly contract table CSV:", error);
                return [];
            }
        };

    const freezeDsoDateApi = async () => {
        props.setLoading(true);
        try {
            if(freezeDSODate === "") {
                 props.setSnackInfo("Please Select Freeze Date...", "info");
                 return;
            }

            const obj = {
                newDsoDate: freezeDSODate
            };
            const response = await HttpService.freezeDsoDate(
                obj
            );
            if (response?.status === 200) {
                props.setSnackInfo("DSO date Freeze SuccessFully!", "success");
            }
        } catch (error) {
            console.error("Error while DSO Freeze Date", error);

            let message = "Something went wrong!";
            if (error?.response?.data?.message) {
                message = error.response.data.message;
            } else if (error?.message) {
                message = error.message;
            }

            props.setSnackInfo(message, "error");
        } finally {
            props.setLoading(false);
        }
    }

    const handleClearAllFilters = () => {
        setSelectedLocation([]);
        setSelectedExperienceCenter([]);
        setStoreDateFilter({ startDate: "", endDate: "" });
        setClearTriggered(true);
    };

    const isSubmitDisabled = !(
        selectedLocation.length > 0 ||
        selectedExperienceCenter.length > 0 ||
        (storeDateFilter.startDate && storeDateFilter.endDate)
    );

    const handleCloseDialog = () => {
        setDialogOpen(false);
        setRemarks("");
        setProjectValue(0);
        setSelectedProjects([]);
        setFreezeDate("");
        setProjectList([]);
        setShowProjects(false);
    };

    // const handleSubmit = async () => {
    //     bottomsUpDataFunction();
    //     handleCloseDialog();
    // };

    const handleSubmitAllFilters = () => {
         bottomsUpDataFunction();
    };

    const uniqueExperienceCentersBottoms = React.useMemo(() => {
        const set = new Set();
        Object.values(bottomsUpData).forEach((monthEntries) => {
            if (Array.isArray(monthEntries)) {
                monthEntries.forEach((entry) => {
                    set.add(entry.experienceCenterName);
                });
            }
        });
        
        // return Array.from(set);
        return Array.from(set).sort((a, b) => {
            if (a === "Total") return 1;   
            if (b === "Total") return -1; 
            return a.localeCompare(b);
        });
    }, [bottomsUpData]);

    const headers = [
        { label: "Sl. No.", key: "index" },
        { label: "Project No.", key: "projectNo" },
        { label: "Lead No.", key: "leadNo" },
        { label: "Value (INR)", key: "value" },
        { label: "City", key: "city" },
        { label: "Exp. Ctr. Name", key: "expCenter" },
        { label: "Current Stage", key: "currentStage" },
        { label: "Sales Won Date", key: "salesWonDate" },
        // {
        //     label: "Design Kick-Off Internal Approval Date",
        //     key: "designKickOffInternalApprovalDate",
        // },
        { label: "Tentative Design Closure Date (Committed Date)", key: "closureDate" },
        // { label: "Projection DSO Commited At", key: "projectionDSOCommitedUpdatedAt" },
        { label: "DSO Month Change (Slip On)", key: "designHealthSecondApprovalsDate" },
        { label: "Internal Design Sign-Off Date (IDSO)", key: "internalDesignSignOffDate" },
    ];

    const csvData = modelData.map((item, i) => ({
        _id: item?._id,
        index: i + 1,
        projectNo: item?.erpProjectNo || "N/A",
        leadNo: item?.lead_no || "N/A",
        value: item?.staticSalesWonBudget || "N/A",
        city: item?.cityName || "N/A",
        expCenter: item?.experienceCenterName || "N/A",
        currentStage:
            item?.currentStage ??
            item?.leadId?.currentStage ??
            item?.lead?.currentStage ??
            "N/A",
        salesWonDate: item?.leadWonDate
            ? moment(item?.leadWonDate).format("DD-MM-YYYY")
            : "-",
        // designKickOffInternalApprovalDate:
        //     item?.designKickOffInternalApprovalDate
        //         ? moment(item?.designKickOffInternalApprovalDate).format(
        //               "DD-MM-YYYY"
        //           )
        //         : "-",
        closureDate: (item?.closureDate && item?.closureDate)
            ? moment(item?.closureDate).format("DD-MM-YYYY")
            : "-",
        // projectionDSOCommitedUpdatedAt: (item?.projectionDSOCommitedUpdatedAt && item?.projectionDSOCommitedUpdatedAt)
            // ? moment(item?.projectionDSOCommitedUpdatedAt).format("DD-MM-YYYY")
            // : "-",
        designHealthSecondApprovalsDate: (item?.designHealthSecondApprovalsDate && item?.designHealthSecondApprovalsDate)
            ? moment(item?.designHealthSecondApprovalsDate).format("DD-MM-YYYY")
            : "-",
        internalDesignSignOffDate: (item?.internalDesignSignOffDate && item?.internalDesignSignOffDate)
            ? moment(item?.internalDesignSignOffDate).format("DD-MM-YYYY")
            : "-",
    }));

    const csvDownloadHandler = () => {
        if (csvButtonRef.current) {
            csvButtonRef.current.link.click();
        }
    };

    const openModel = (data) => {
        setModelData(data || []);
        setShowDetailedModal(true);
    };

    // Minimum = today's date
    const getMinDate = () => {
        return new Date().toISOString().split("T")[0];
    };

    // Maximum = last day of the third month from now
    const getMaxDate = () => {
        const today = new Date();
        const maxDate = new Date(today.getFullYear(), today.getMonth() + 4, 0); // 4 because we include the current month
        return maxDate.toISOString().split("T")[0];
    };

    const getCurrentMonthDSODateRange = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth(); // 0-indexed

        const firstDay = new Date(year, month, 1).toISOString().split('T')[0];
        const lastDay = new Date(year, month + 1, 0).toISOString().split('T')[0];

        return { minDate: firstDay, maxDate: lastDay };
    };
    const { minDate, maxDate } = getCurrentMonthDSODateRange();


    const handleOpenPopup = () => {
        setOpenDSOPopUp(true);
    };

    const handleClosePopup = () => {
        setOpenDSOPopUp(false);
        setFreezeDSODate("");
    };

    const handleSubmit = () => {
        if (freezeDSODate) {
        setConfirmDSOOpen(true);
        }
    };

    const handleConfirm = () => {
        setConfirmDSOOpen(false);
        setOpenDSOPopUp(false);
        setFreezeDSODate("");
        freezeDsoDateApi();
        setClearTriggered(true);
    };

    const handleCancelConfirmation = () => {
        setConfirmDSOOpen(false);
    };

            // Function to prepare data for transposed view
        const getTransposedData = () => {
            const transposed = {};
            
            // Create a structure where months become columns and experience centers become rows
            const allMonths = Object.keys(bottomsUpData);
            const allCenters = uniqueExperienceCentersBottoms;
            
            // For each experience center, create a row
            allCenters.forEach(center => {
                transposed[center] = {
                    center: center,
                    // For each month, add count and value
                    ...allMonths.reduce((acc, month) => {
                        const monthData = bottomsUpData[month];
                        const entry = monthData?.find(e => e.experienceCenterName === center);
                        
                        acc[`${month}_count`] = entry?.count > 0 ? entry.count : 0;
                        acc[`${month}_value`] = entry?.value > 0 ? entry.value : 0;
                        
                        return acc;
                    }, {})
                };
            });
            
            return { transposedData: transposed, months: allMonths };
        };

        const renderTransposedTable = () => {
            const { transposedData, months } = getTransposedData();
            const centers = Object.keys(transposedData);
            
            return (
                <TableContainer className={classes.tableContainer}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.topLeftHeader} rowSpan={2}>
                                    <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.4 }}>
                                        <span>Experience Center</span>
                                        <br />
                                        <span>Metric</span>
                                    </div>
                                </TableCell>
                                
                                {months.map(month => (
                                    <TableCell
                                        key={month}
                                        className={classes.headerCell}
                                        colSpan={2}>
                                        {month}
                                    </TableCell>
                                ))}
                            </TableRow>
                            
                            <TableRow>
                                {months.map(month => (
                                    <React.Fragment key={month}>
                                        <TableCell className={classes.headerCell}>
                                            Count
                                        </TableCell>
                                        <TableCell className={classes.headerCell}>
                                            Value
                                        </TableCell>
                                    </React.Fragment>
                                ))}
                            </TableRow>
                        </TableHead>
                        
                        <TableBody>
                            {centers.map(center => (
                                <TableRow key={center}>
                                    <TableCell className={classes.monthCell}>
                                        {center}
                                    </TableCell>
                                    
                                    {months.map(month => {
                                        const data = transposedData[center];
                                        const hasData = data[`${month}_count`] !== "-" || data[`${month}_value`] !== "-";
                                        const entry = bottomsUpData[month]?.find(e => e.experienceCenterName === center);
                                        
                                        return (
                                            <React.Fragment key={`${center}-${month}`}>
                                                <TableCell
                                                    className={classes.bodyCell}
                                                    style={{
                                                        cursor: hasData ? "pointer" : "default",
                                                        fontWeight: "bold",
                                                    }}
                                                    onClick={() => hasData && entry?.data && openModel(entry.data)}>
                                                    {data[`${month}_count`]}
                                                </TableCell>
                                                <TableCell
                                                    className={classes.bodyCell}
                                                    style={{
                                                        cursor: hasData ? "pointer" : "default",
                                                        fontWeight: "bold",
                                                    }}
                                                    onClick={() => hasData && entry?.data && openModel(entry.data)}>
                                                    {data[`${month}_value`]}
                                                </TableCell>
                                            </React.Fragment>
                                        );
                                    })}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            );
        };

    return (
        <>
            {/*-Start--Filter Section */}
            <Paper className={classes.paperWrapper}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={3}>
                        <FormControl fullWidth>
                            <Autocomplete
                                multiple
                                value={selectedLocation}
                                options={commonLocation}
                                getOptionLabel={(option) => option.name}
                                onChange={(e, val) => setSelectedLocation(val)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label='Select Location'
                                        variant='outlined'
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormControl fullWidth>
                            <Autocomplete
                                multiple
                                value={selectedExperienceCenter}
                                options={commonExpCenter}
                                getOptionLabel={(option) => option.name}
                                onChange={(e, val) =>
                                    setSelectedExperienceCenter(val)
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label='Select Exp-Center'
                                        variant='outlined'
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            label='Expected DSO From Date'
                            type='date'
                            variant='outlined'
                            value={storeDateFilter.startDate}
                            onChange={(e) =>
                                setStoreDateFilter({
                                    ...storeDateFilter,
                                    startDate: e.target.value,
                                })
                            }
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            label='Expected DSO End Date'
                            type='date'
                            variant='outlined'
                            value={storeDateFilter.endDate}
                            onChange={(e) =>
                                setStoreDateFilter({
                                    ...storeDateFilter,
                                    endDate: e.target.value,
                                })
                            }
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                        />
                    </Grid>
                </Grid>

                <Box mt={3} display='flex' gap={2} flexWrap='wrap'>
                    <Button
                        variant='contained'
                        color='primary'
                        style={{
                            color: "#fff",
                            padding: "6px 20px",
                            whiteSpace: "nowrap",
                            backgroundColor: isSubmitDisabled
                                ? "#cccccc"
                                : "#4caf50",
                            opacity: isSubmitDisabled ? 0.5 : 1,
                        }}
                        onClick={handleSubmitAllFilters}
                        disabled={isSubmitDisabled}>
                        Submit
                    </Button>
                    <Button
                        variant='contained'
                        color='secondary'
                        style={{ marginLeft: "10px" }}
                        onClick={handleClearAllFilters}>
                        Clear Filter
                    </Button>
                    {userDetails?.roles?.find(
                        role =>
                        role.name === ROLENAME.Admin) &&
                        <Button
                        variant='contained'
                        color='primary'
                        style={{ marginLeft: "10px" }}
                        onClick={handleOpenPopup}
                        >
                        Freeze DSO Date
                        </Button>
                    }
                </Box>
            </Paper>
            {/*--END---Filter Section */}


                       {/* --START-- Table 3 - Bottoms up data */}
                       <Paper className={classes.paperWrapper}>
                <Box mb={1} display="flex" justifyContent="center" alignItems="center" gap={3}>
                    <Typography className={classes.title} style={{ marginTop: '20px' }}>
                        Bottoms Up
                    </Typography>
                    <CSVLink
                        data={monthlyContractTableCsvData}
                        filename={`Monthly_Contract_Bottoms_Up_${moment().format('YYYY-MM-DD')}.csv`}
                        ref={monthlyContractTableCsvButtonRef}
                        style={{ textDecoration: 'none', display: 'none' }}
                    />
                    <Button
                        variant='contained'
                        size="small"
                        startIcon={<DownloadOutlined />}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            
                            const csvData = generateMonthlyContractTableCsvData();

                            if (csvData.length > 0) {
                                setMonthlyContractTableCsvData(csvData);
                                setTimeout(() => {
                                    setTriggerDownload(true);
                                }, 100);
                            } else {
                                props.setSnackInfo("No data available to export", "warning");
                            }
                        }}
                        style={{
                            backgroundColor: "#355025",
                            color: "#FFF2EB",
                            padding: "0.2rem 1rem",
                            fontSize: '0.75rem',
                            marginLeft: '20px'
                        }}
                    >
                        Download CSV
                    </Button>
                </Box>

                <Box display="flex" justifyContent="flex-start" alignItems="center" mb={2}>
                    <Button
                        variant='contained'
                        color='primary'
                        style={{ backgroundColor: "#F47E46", color: "#FFF2EB" }}
                        onClick={() => setIsTransposed(!isTransposed)}>
                        {isTransposed ? 'Transpose Table' : 'Show Normal View'}
                    </Button>
                </Box>

                {isTransposed ? renderTransposedTable() : (
                    <TableContainer className={classes.tableContainer}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.topLeftHeader} rowSpan={2}>
                                        <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.4 }}>
                                            <span>Experience Center</span>
                                            <br />
                                            {/*<span>Committed Month</span>*/}
                                        </div>
                                    </TableCell>
                                    {uniqueExperienceCentersBottoms.map((center) => (
                                        <TableCell
                                            key={center}
                                            className={classes.headerCell}
                                            colSpan={2}>
                                            {center}
                                        </TableCell>
                                    ))}
                                </TableRow>
                                <TableRow>
                                    {uniqueExperienceCentersBottoms.map((center, idx) => (
                                        <React.Fragment key={center + idx}>
                                            <TableCell className={classes.headerCell}>
                                                Count
                                            </TableCell>
                                            <TableCell className={classes.headerCell}>
                                                Value
                                            </TableCell>
                                        </React.Fragment>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {Object.entries(bottomsUpData)
                                    .map(([monthKey, entries]) => (
                                        <TableRow key={monthKey}>
                                            <TableCell className={classes.monthCell}>
                                                {monthKey}
                                            </TableCell>
                                            {uniqueExperienceCentersBottoms.map((center, colIndex) => {
                                                const entry = entries.find(
                                                    (e) => e.experienceCenterName === center
                                                );
                                                return (
                                                    <React.Fragment key={center + colIndex}>
                                                        <TableCell
                                                            className={classes.bodyCell}
                                                            style={{
                                                                cursor: entry ? "pointer" : "default",
                                                                fontWeight: "bold",
                                                            }}
                                                            onClick={() => entry?.data && openModel(entry.data)}>
                                                            {entry?.count > 0 ? entry.count : 0}
                                                        </TableCell>
                                                        <TableCell
                                                            className={classes.bodyCell}
                                                            style={{
                                                                cursor: entry ? "pointer" : "default",
                                                                fontWeight: "bold",
                                                            }}
                                                            onClick={() => entry?.data && openModel(entry.data)}>
                                                            {entry?.value > 0 ? entry.value : 0}
                                                        </TableCell>
                                                    </React.Fragment>
                                                );
                                            })}
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Paper>
            {/*--END-- Table 3 - Bottoms up data */}

            
            {/* Remarks Dialog */}
            <Dialog
                open={dialogOpen}
                onClose={handleCloseDialog}
                maxWidth='sm'
                fullWidth>
                <DialogTitle>Enter Project Details</DialogTitle>
                <DialogContent>
                    {/* Toggle Button */}
                    <Box
                        display='flex'
                        justifyContent='space-between'
                        alignItems='center'
                        mb={1}>
                        <Typography variant='subtitle2'>
                            Select Projects
                        </Typography>
                        <Button
                            variant='outlined'
                            size='small'
                            onClick={() => setShowProjects((prev) => !prev)}
                            style={{ textTransform: "none" }}>
                            {showProjects ? "Hide Projects" : "Show Projects"}
                        </Button>
                    </Box>

                    {/* Project Table */}
                    {showProjects && (
                        <Box
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: 4,
                                maxHeight: 200,
                                overflowY: "auto",
                                marginBottom: 16,
                            }}>
                            <Table size='small' stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell padding='checkbox'>
                                            <Checkbox
                                                checked={
                                                    selectedProjects.length ===
                                                    projectList.length
                                                }
                                                indeterminate={
                                                    selectedProjects.length >
                                                        0 &&
                                                    selectedProjects.length <
                                                        projectList.length
                                                }
                                                onChange={
                                                    toggleSelectAllProjects
                                                }
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <strong>S. No.</strong>
                                        </TableCell>
                                        <TableCell>
                                            <strong>Project Name</strong>
                                        </TableCell>
                                        <TableCell align='right'>
                                            <strong>Value (₹ in Lakh)</strong>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {projectList.map((project, index) => (
                                        <TableRow key={project.id}>
                                            <TableCell padding='checkbox'>
                                                <Checkbox
                                                    checked={selectedProjects.includes(
                                                        index
                                                    )}
                                                    onChange={() =>
                                                        toggleProjectSelection(
                                                            index
                                                        )
                                                    }
                                                />
                                            </TableCell>
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>
                                                <a
                                                    href={`/project-logs/${project._id}`}
                                                    target='_blank'
                                                    rel='noopener noreferrer'
                                                    style={{
                                                        color: "rgba(0, 0, 0, 0.87)",
                                                        textDecoration:
                                                            "underline",
                                                    }}>
                                                    {project.erpProjectNo}
                                                </a>
                                            </TableCell>
                                            <TableCell align='right'>
                                                {project.staticSalesWonBudget}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    )}

                    {/* Value Field */}
                    <TextField
                        label='Selected Project Value (₹ in Lakhs)'
                        type='number'
                        fullWidth
                        variant='outlined'
                        value={projectValue}
                        InputProps={{ readOnly: true }}
                        style={{ marginBottom: 16 }}
                    />

                    {/* Freeze Date */}
                    <TextField
                        label="Freeze Date"
                        type="date"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        value={freezeDate}
                        onChange={(e) => setFreezeDate(e.target.value)}
                        style={{ marginBottom: 16 }}
                        inputProps={{
                            min: getMinDate(),
                            max: getMaxDate(),
                        }}
                    />

                    {/* Remarks */}
                    <TextField
                        label='Remarks'
                        fullWidth
                        multiline
                        minRows={3}
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                        variant='outlined'
                    />
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleCloseDialog} color='inherit'>
                        Cancel
                    </Button>
                    <Button
                        onClick={() => setConfirmOpen(true)}
                        color="primary"
                        variant="contained"
                        disabled={
                            remarks.trim() === "" ||
                            selectedProjects.length === 0 ||   
                            !projectValue ||
                            !freezeDate
                        }
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Table Popup Modal Start  */}
            <Modal
                open={showDetailedModal}
                onClose={() => setShowDetailedModal(false)}>
                <Box className={classes.modalWrapper}>
                    {/* Header */}
                    <div className={classes.modalHeader}>
                        {/*<Typography variant='h6'>Monthly Contract</Typography> */}
                        <IconButton
                            className={classes.closeButton}
                            onClick={() => setShowDetailedModal(false)}>
                            <CloseIcon />
                        </IconButton>
                    </div>

                    {/* CSV Download */}
                    <div className={classes.csv}>
                        <CSVLink
                            headers={headers}
                            filename={`monthlyContract.csv`}
                            data={csvData}
                            ref={csvButtonRef}
                            style={{ display: "none" }}
                        />
                        <Button
                            onClick={csvDownloadHandler}
                            variant='contained'
                            style={{
                                backgroundColor: "#355025",
                                color: "#FFF2EB",
                            }}>
                            Download CSV
                        </Button>
                    </div>

                    {/* Table Content */}
                    <TableContainer
                        component={Paper}
                        className={classes.tableContainer}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {headers.map((h) => (
                                        <TableCell
                                            key={h.key}
                                            className={classes.headerCell}>
                                            {h.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {csvData.length === 0 ? (
                                    <TableRow>
                                        <TableCell
                                            colSpan={headers.length}
                                            align='center'>
                                            No data available
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    csvData.map((row, i) => (
                                        <TableRow
                                            key={i}
                                            className={
                                                i % 2 === 0
                                                    ? classes.tableRowEven
                                                    : classes.tableRowOdd
                                            }>
                                            {headers.map((h) => {
                                                const isProjectNo =
                                                    h.key === "projectNo";
                                                const isLeadNo =
                                                    h.key === "leadNo";
                                                return (
                                                    <TableCell
                                                        key={h.key}
                                                        className={
                                                            classes.valueCell
                                                        }>
                                                        {(isProjectNo ||
                                                            isLeadNo) &&
                                                        row._id ? (
                                                            <a
                                                                href={`/project-logs/${row._id}`}
                                                                target='_blank'
                                                                rel='noopener noreferrer'
                                                                style={{
                                                                    color: "rgba(0, 0, 0, 0.87)",
                                                                    textDecoration:
                                                                        "underline",
                                                                }}>
                                                                {row[h.key]}
                                                            </a>
                                                        ) : (
                                                            row[h.key] || "NA"
                                                        )}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Modal>
            {/* Popup Modal END  */}

            {/* Freeze DSO Date Popup */}
            <Dialog open={openDSOPopUp} onClose={handleClosePopup} maxWidth="sm" fullWidth>
                <DialogTitle>Freeze DSO Date</DialogTitle>
                <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                    <TextField
                        label="Freeze DSO Date"
                        type="date"
                        variant="outlined"
                        fullWidth
                        value={freezeDSODate}
                        onChange={(e) => setFreezeDSODate(e.target.value)}
                        InputLabelProps={{
                        shrink: true,
                        style: {
                            color: 'black',
                            fontWeight: 'bold',
                            fontSize: '16px',
                        },
                        }}
                        inputProps={{
                                min: minDate,
                                // max: maxDate,
                        }}
                        InputProps={{
                        style: {
                            cursor: 'pointer',
                            color: 'black',
                            borderRadius: '4px',
                        },
                        }}
                    />
                    </Grid>
                </Grid>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleClosePopup} color="primary">
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit}
                    color="secondary"
                    disabled={!freezeDSODate}
                >
                    Submit
                </Button>
                </DialogActions>
            </Dialog>

            {/* Confirmation Dialog */}
            <Dialog open={confirmDSOOpen} onClose={handleCancelConfirmation}>
                <DialogTitle>Confirm Freeze</DialogTitle>
                <DialogContent>
                <DialogContentText>
                    Are you sure you want to freeze the DSO date to{" "}
                    <strong>{moment(freezeDSODate).format("DD-MM-YYYY")}</strong>?
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleCancelConfirmation} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleConfirm} color="secondary">
                    Confirm
                </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default connect(null, { setLoading, setSnackInfo })(
    MonthlyContractFreeze
);
